import React from 'react';
import { ImageGallery } from '../ui/carousel-circular-image-gallery';

const productImages = [
  { title: "Pepper", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316881/Pepper_bvyq5y.png" },
  { title: "Coconut Chips", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316776/coconut_yh6dfc.png" },
  { title: "Blue Tea", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316123/Blue_Tea_2_hkxfyw.png" },
  { title: "Carrot Oil", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316124/carrot_ian2pj.png" },
  { title: "Red Tea", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316118/Red_Tea2_zeihlj.png" },
  { title: "Cinnamon", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782313478/4_hyjqbc.png" },
  { title: "Virgin Oil", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782313478/6_cntvdy.png" },
  { title: "Lavanya", url: "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782316123/Lavanya_vnof6p.png" }
];

const Lifestyle = () => {
  return (
    <section className="py-24 px-6 md:px-12 lg:px-24 bg-brand-sand relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 relative z-10">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-darkSage">WELLNESS LIFESTYLE</h2>
        </div>
        
        {/* Circular Image Gallery Component passes the Cloudinary URLs */}
        <div className="relative z-20">
          <ImageGallery images={productImages} />
        </div>
      </div>
    </section>
  );
};

export default Lifestyle;